<template>
  <div class="pa-1" style="margin-bottom: 16px; margin-left: 2px;">
    <v-layout row>
      <v-flex xs10> {{label || title}}</v-flex>
      <v-flex xs2> <v-btn color="info" small @click="add_line">Add</v-btn>
      </v-flex>
    </v-layout>

    <v-layout row v-for="(v, idx) in val" :key="idx" class="elevation-1 pa-1" style="margin-bottom: 16px; margin-left: 2px;">
      <v-flex x11>

          <v-layout :row="direction == 'row'" :column="direction != 'row'">
            <v-flex v-for="field in form" :key="field.name">
              <div v-if="field.type == 'group'">
                <div v-for="gfield in field.fields">
                  <component v-bind:is="get_field_type(gfield.type)" v-bind="gfield" v-model="v.data" :ref="gfield.name"></component>
                </div>
              </div>
              <div v-else>
                <component v-bind:is="get_field_type(field.type)" v-bind="field" v-model="v.data" :ref="field.name"></component>
              </div>
            </v-flex>
          </v-layout>

      </v-flex>
      <v-flex xs1>
          <v-icon right @click.stop="del_line(idx)">delete</v-icon>
      </v-flex>
    </v-layout>
</div>
</template>

<script>

import * as FormItems from '@/components/form_items'

import {EventMixin} from '@/lib/mixins.js';
import ContentModel from '@/models/content.js'

export default {
  mixins: [EventMixin],
  props: [
    'value',
    'name',
    'label',
    'title',
    'form',
    'direction'
  ],
  components: {
    ...FormItems
  },
  methods: {
    get_field_type(field_type) {
      return ContentModel.get_field_type(field_type);
    },
    add_line () {
      var new_val = this.val;
      new_val.push({data: {}});
      this.val = new_val;
    },
    del_line (idx) {
      var new_list = this.val;
      new_list.splice(idx,1);
      this.val = new_list;
    }
  },
  computed: {
    val: {
      get () {
        var ret = _.get(this.value, this.name) || [];
        if (!_.isArray(ret)) ret = [];
        return ret;
      },
      set (val) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, val);
        this.$emit("input", value);
      }
    }
  }
}
</script>
